// State
export const state = () => ({
  tempData: {},
  thirdPartyPayments: [],
  depositFlow: {},
  checkExist: {},
  checkDeposit: false,
  companyCryptoWallet: [],
  depositEventsBody: {}
})

// Actions
export const actions = {
  async create({ commit, state }, data) {
    const form = { ...data }
    try {
      const response = await this.$axios.post(`/deposits`, {
        ...form,
        event_data: { ...state.depositEventsBody }
      })
      commit('setTempData', response.data)
      return response.data
    } catch (error) {}
  },
  async confirm({ commit }, id) {
    try {
      await this.$axios.put(`/deposits/${id}`, {})
      commit('checkDeposit', true)
      return true
    } catch (error) {
      return false
    }
  },
  async revoke({ commit }, id) {
    try {
      await this.$axios.put(`/deposits/revoke/${id}`, {})
      commit('checkDeposit', false)
      return true
    } catch (error) {
      return false
    }
  },
  async checkExist({ commit }, _) {
    try {
      const response = await this.$axios.get(`/deposits/check/is-exists`)
      commit('checkExist', response.data)
      return response.data
    } catch (error) {
      return null
    }
  },
  async getThirdPartyPayments({ commit }, _) {
    try {
      const response = await this.$axios.get('third-party-payments/providers')
      const sortItems = [...response.data]
        .sort((a, b) => a.sequence - b.sequence)
        .map(provider => ({
          ...provider,
          channels: provider.channels
        }))
      commit('setThirdPartyPayments', sortItems)
    } catch (error) {}
  },
  async depositFlow({ commit }, currency) {
    try {
      const response = await this.$axios.get(`website-setting/deposit-flow/${currency}`)
      commit('depositFlow', response.data)
      // commit('depositFlow', {
      // 	deposit_type: 2,
      // 	is_bank_transfer_enabled: true,
      // 	is_third_party_payment_enabled: true
      // })
    } catch (error) {}
  },
  async depositCrypto({ state }, data) {
    try {
      const response = await this.$axios.post(`deposits/crypto`, {
        ...data,
        event_data: { ...state.depositEventsBody }
      })
      return response.data
    } catch (error) {
      return false
    }
  },
  openDepositThirdParty({ commit }, data) {
    const queryParams = new URLSearchParams(data).toString()
    window.open(`/payment?${queryParams}`, '_blank')
    return true
  },
  async createDepositThirdParty({ commit, state }, data) {
    // const windowLink = window.open()
    const depositEventBodyCookie = this.$cookie.get('deposit_third_party_event')
    let depositEventBody = {}
    if (typeof depositEventBodyCookie === 'object') {
      depositEventBody = depositEventBodyCookie
    }
    let redirectionUrl = null
    try {
      const response = await this.$axios.post(`deposits/third-party`, {
        ...data,
        event_data: { ...depositEventBody }
      })
      commit('setTempData', response.data)
      if (response.data.is_qr) {
        // Make sure to change the logic in amb page
        // Save the deposit id with the qr_code storage to make sure the deposit is match with the qr code
        localStorage.setItem(
          'qr_code',
          `${response.data.id}:${encodeURIComponent(response.data.tp_payment_link)}`
        )

        redirectionUrl = `/third-party-payment?amount=${response.data.deposit_amount}&currency=${
          response.data.currency
        }&created_at=${encodeURIComponent(response.data.created_at)}&tp_gateway_code=${
          response.data.tp_gateway_code
        }`
        return redirectionUrl
      } else {
        redirectionUrl = getThirdPartyPaymentLinkByProvider(
          response.data.tp_payment_link,
          response.data.tp_gateway_code,
          this.$router
        )
        return redirectionUrl
      }
    } catch (error) {
      return {
        error: true,
        code: error?.response?.data?.code,
        message: error?.response?.data?.message
      }
    }
  },
  async getCompanyCryptoWallet({ commit }, params) {
    try {
      const response = await this.$axios.get(`/company-crypto-wallet/deposit/settings`, { params })
      commit('setCompanyCryptoWallet', response.data)
      return response.data
    } catch (error) {
      return false
    }
  }
}

// Mutations
export const mutations = {
  setTempData: (state, data) => {
    state.tempData = data
  },
  setThirdPartyPayments: (state, data) => {
    state.thirdPartyPayments = data
  },
  depositFlow: (state, data) => {
    state.depositFlow = data
  },
  checkExist: (state, data) => {
    state.checkExist = data
  },
  checkDeposit: (state, data) => {
    state.checkDeposit = data
  },
  setDepositEventsBody: (state, data) => {
    state.depositEventsBody = data
  },
  setCompanyCryptoWallet: (state, data) => {
    state.companyCryptoWallet = data
  }
}

// Function to generate payment links for different payment providers
const paymentLinkProviders = {
  third_party_papaya_pay: (link, router) =>
    `${link}?redirectionUrl=${window.location.origin}${router.currentRoute.fullPath}`
}

const getThirdPartyPaymentLinkByProvider = (link, provider, router) => {
  const generateLink = paymentLinkProviders[provider]
  return generateLink ? generateLink(link, router) : link
}
